import { render } from "./Aetheryte.vue?vue&type=template&id=b40619b0"
import script from "./Aetheryte.vue?vue&type=script&lang=js"
export * from "./Aetheryte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__